<div class="users-container mat-elevation-z2">
    <div class="table-header">
        <div class="header-top">
          <h2>Users Management</h2>
          <button mat-raised-button color="primary" (click)="openUserDialog()">Add User</button>
        </div>
      
        <mat-form-field appearance="outline" class="search-field">
          <mat-label>Search users</mat-label>
          <input matInput (keyup)="applyFilter($event)" placeholder="Search by name or email">
        </mat-form-field>
    </div>
      
  
    <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z1 full-width-table">
  
      <!-- Full Name Column -->
      <ng-container matColumnDef="fullName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Full Name</th>
        <td mat-cell *matCellDef="let user">{{ user.fullName }}</td>
      </ng-container>
  
      <!-- Email Column -->
      <ng-container matColumnDef="email">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Email</th>
        <td mat-cell *matCellDef="let user">{{ user.email }}</td>
      </ng-container>
  
      <!-- Role Column -->
      <ng-container matColumnDef="role">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Role</th>
        <td mat-cell *matCellDef="let user">{{ user.role || (user.roles?.join(', ') || '-') }}</td>
      </ng-container>
  
      <!-- Actions Column -->
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>Actions</th>
        <td mat-cell *matCellDef="let user">
          <button mat-icon-button [matMenuTriggerFor]="userActionsMenu" matTooltip="User Actions">
            <mat-icon>menu</mat-icon>
          </button>
          <mat-menu #userActionsMenu="matMenu">
            <button mat-menu-item (click)="openUserDialog(user)">
              <mat-icon>edit</mat-icon>
              <span>Edit User</span>
            </button>
            <button mat-menu-item (click)="deleteUser(user.id)">
              <mat-icon>delete</mat-icon>
              <span>Delete User</span>
            </button>
          </mat-menu>
        </td>
      </ng-container>
  
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  
    <mat-paginator [pageSizeOptions]="[5, 10, 25]" showFirstLastButtons></mat-paginator>
</div>
  
